import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { SAVED_SCREENS_QUERY_KEY } from "./useSavedScreens";

type UpdateSavedScreenBody = components["schemas"]["UpdateSavedScreenBody"];
type SavedScreenResponse = components["schemas"]["SavedScreenResponse"];

export type UpdateSavedScreenInput = {
  saved_screen_id: string;
  body: UpdateSavedScreenBody;
};

export function useUpdateSavedScreen() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<SavedScreenResponse, Error, UpdateSavedScreenInput>({
    mutationFn: async ({ saved_screen_id, body }) => {
      const { data, error } = await client.PATCH(
        "/api/screens/{saved_screen_id}",
        {
          params: { path: { saved_screen_id } },
          body,
        },
      );
      if (error !== undefined) {
        throw new Error("Failed to update saved screen");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: SAVED_SCREENS_QUERY_KEY });
    },
  });
}
